module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetMedium@2x.83c143d.jpg";